import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { errorNotification } from '../../common/redux/actions/CapeNotificationActions';
import {
  pinUserReportRequestActionCreator,
  currentUserReportActionCreator,
} from '../../user/redux/actions/UserActions';
import TranslatedLink from '../../wizard/common/components/TranslatedLink';
import DashboardReportTypes from '../redux/actions/types/DashboardReportTypes';
import Icons from '../../../core/modules/common/components/Icons';
import { canPerformPinning } from '../redux/selectors/DashboardSelectors';

export class ReportItemContainer extends Component {
  togglePin = (e) => {
    e.preventDefault();
    const pinned = !this.props.report.pinned;
    const { reportCode } = this.props.report;

    if (pinned && this.props.canPerformPinning === false) {
      this.props.errorNotification('Number of favourite reports exceeded. You should first unpin one of the favourite reports to pin this one as a favourite report');
      return;
    }

    this.props.pinUserReportRequestActionCreator({
      pinned,
      reportCode,
    });
  }

  openDeleteModal = (e) => {
    e.preventDefault();
    this.props.openDeleteModal(this.props.report.saved.id);
  }

  render() {
    const {
      type,
      report,
    } = this.props;

    const {
      name,
      reportCode,
      pinned,
      mainReportCategoryName,
    } = report;

    let wizardUrl = `report-wizard/${reportCode}`;

    if (type === DashboardReportTypes.SAVED) {
      wizardUrl += `?saved=true&id=${report.saved.id}`;
    }
    if (type === DashboardReportTypes.RECENT) {
      wizardUrl += `?recent=true&id=${report.recent.id}`;
    }

    return (
      <TranslatedLink to={wizardUrl} target="_blank">
        <div className="reports__report">
          {type !== DashboardReportTypes.SAVED &&
            <button
              type="button"
              className={`btn-pin ${pinned ? 'pinned' : ''}`}
              onClick={this.togglePin}
            >
              <Icons.ThumbtackIcon />
            </button>
          }
          {type === DashboardReportTypes.SAVED &&
            <button
              type="button"
              className="btn-delete-saved"
              onClick={this.openDeleteModal}
            >
              <Icons.Custom name="trash-o" />
            </button>
          }
          <span className={`event-type-label ${mainReportCategoryName.replace(/\s/g, '-').toLowerCase()}`}>
            {mainReportCategoryName}
          </span>
          <h5 className="report-name">
            {name}
          </h5>
          {type === DashboardReportTypes.SAVED &&
            <h6 className="ellipsis">{report.saved.selectionName}</h6>
          }
          {type === DashboardReportTypes.RECENT && report.recent && report.recent.createTime &&
            <h6 className="ellipsis">{moment(report.recent.createTime).format('DD/MM/YYYY HH:mm')}</h6>
          }
        </div>
      </TranslatedLink>
    );
  }
}

ReportItemContainer.propTypes = {
  type: PropTypes.string.isRequired,
  report: PropTypes.objectOf(PropTypes.shape),
  errorNotification: PropTypes.func,
  canPerformPinning: PropTypes.bool,
  openDeleteModal: PropTypes.func,
  pinUserReportRequestActionCreator: PropTypes.func,
};

const mapStateToProps = state => ({
  canPerformPinning: canPerformPinning(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  errorNotification,
  pinUserReportRequestActionCreator,
  currentUserReportActionCreator,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReportItemContainer);
